import AuthMiddleware from "@/middleware/auth";

const AllPhysicians = () =>
  import(
    /* webpackChunkName: "physician" */ "@/views/physicians/AllPhysicians.vue"
  );
const ActivePhysicians = () =>
  import(
    /* webpackChunkName: "physician" */ "@/views/physicians/ActivePhysicians.vue"
  );
const InActivePhysicians = () =>
  import(
    /* webpackChunkName: "physician" */ "@/views/physicians/InActivePhysicians.vue"
  );
const PhysicianRouter = [
  {
    path: "/physicians",
    name: "AllPhysicians",
    beforeEnter: AuthMiddleware.user,
    component: AllPhysicians,
    meta: {
      title: "PHYSICIANS",
    },
  },

  {
    path: "/physicians/active",
    name: "ActivePhysicians",
    beforeEnter: AuthMiddleware.user,
    component: ActivePhysicians,
    meta: {
      title: " PHYSICIANS",
    },
  },
  {
    path: "/physicians/inactive",
    name: "InActivePhysicians",
    beforeEnter: AuthMiddleware.user,
    component: InActivePhysicians,
    meta: {
      title: "PHYSICIANS",
    },
  },
];

export { PhysicianRouter };
